export default "__VITE_ASSET__BXgOQTB7__"